import * as types from './mutation-types';
import { compileAsyncMutations } from '@/utils/async';


const mutations = {};

// For each async mutations, dynamically add three mutations
// See @/utils/async for more details
compileAsyncMutations(mutations, types);

export default mutations;
